import { ReactElement } from 'react';
import { DesignLanguage } from '../../../types';
import { getTextToSpeechVoiceOptions } from './get-text-to-speech-voice-options';

/** Get the label to display to a user for a configured language. */
export function getLanguageLabel({
  designLanguage,
  includeTts,
  includeVt,
  returnJsx
}: {
  designLanguage: DesignLanguage;
  includeTts?: boolean;
  includeVt?: boolean;
  returnJsx?: true;
}): ReactElement[];
export function getLanguageLabel({
  designLanguage,
  includeTts,
  includeVt,
  returnJsx
}: {
  designLanguage: DesignLanguage;
  includeTts?: boolean;
  includeVt?: boolean;
  returnJsx?: false;
}): string;
export function getLanguageLabel({
  designLanguage,
  includeTts = false,
  includeVt = true,
  returnJsx = true
}: {
  designLanguage: DesignLanguage;
  includeTts?: boolean;
  includeVt?: boolean;
  returnJsx?: boolean;
}) {
  const {
    language: languageCode,
    voice,
    ttsFallBackVoice
  } = designLanguage;
  const ttsVoices = getTextToSpeechVoiceOptions(languageCode);
  const { name: language } = window.apm.getLanguage(languageCode) ?? {};
  const { name: ttsVoice } = ttsVoices.find(({ value }) => {
    return value === ttsFallBackVoice;
  }) ?? { name: ttsFallBackVoice };
  const parts = [language];
  if (ttsVoice === voice) {
    parts.push(`${voice} (VT + TTS)`);
  } else {
    if (includeVt && voice) {
      parts.push(`${voice} (VT)`);
    }
    if (includeTts && ttsVoice) {
      parts.push(`${ttsVoice} (TTS)`);
    }
  }
  if (returnJsx) {
    return parts.map((text, i) => {
      return <span key={i}>{i === 0 ? <>{text}</> : <small>{text}</small>}</span>;
    });
  }
  return parts.join(' - ');
}
